/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ClearDeviceResponseDto,
  CreateDeviceAdminDto,
  DeviceDetailDto,
  DeviceListItemDto,
  DevicePartnerDto,
  DevicesAdminControllerListDevicesParams,
  SetDeviceConfigDto,
  SetDeviceConfigResponseDto,
  SetDevicePartnerDto,
  UpdateDeviceConfigDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type devicesControllerSetDeviceConfigResponse201 = {
  data: SetDeviceConfigResponseDto
  status: 201
}

export type devicesControllerSetDeviceConfigResponse401 = {
  data: void
  status: 401
}

export type devicesControllerSetDeviceConfigResponse404 = {
  data: void
  status: 404
}

export type devicesControllerSetDeviceConfigResponse409 = {
  data: void
  status: 409
}

export type devicesControllerSetDeviceConfigResponseSuccess = (devicesControllerSetDeviceConfigResponse201) & {
  headers: Headers;
};
export type devicesControllerSetDeviceConfigResponseError = (devicesControllerSetDeviceConfigResponse401 | devicesControllerSetDeviceConfigResponse404 | devicesControllerSetDeviceConfigResponse409) & {
  headers: Headers;
};

export type devicesControllerSetDeviceConfigResponse = (devicesControllerSetDeviceConfigResponseSuccess | devicesControllerSetDeviceConfigResponseError)

export const getDevicesControllerSetDeviceConfigUrl = (deviceId: string,) => {




  return `/devices/${deviceId}/config`
}

/**
 * Sets a single configuration key on the device to the given boolean or string value, merging it into the existing device config. Turning job_board on also sets fast_flow and check_in_cards on and quality_issue_reporting off.
 * @summary Set a device configuration value
 */
export const devicesControllerSetDeviceConfig = async (deviceId: string,
    setDeviceConfigDto: SetDeviceConfigDto, options?: Parameters<typeof customFetch>[1]): Promise<devicesControllerSetDeviceConfigResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<devicesControllerSetDeviceConfigResponse>(getDevicesControllerSetDeviceConfigUrl(deviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setDeviceConfigDto)
  }
);}





export const getDevicesControllerSetDeviceConfigMutationKey = () => ['devicesControllerSetDeviceConfig'] as const;

export const getDevicesControllerSetDeviceConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,DevicesControllerSetDeviceConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,DevicesControllerSetDeviceConfigMutationVariables, TContext> => {

const mutationKey = getDevicesControllerSetDeviceConfigMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, DevicesControllerSetDeviceConfigMutationVariables> = (props) => {
          const {deviceId,data} = props ?? {};

          return  devicesControllerSetDeviceConfig(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesControllerSetDeviceConfigMutationResult = NonNullable<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>>
    export type DevicesControllerSetDeviceConfigMutationBody = SetDeviceConfigDto
    export type DevicesControllerSetDeviceConfigMutationError = void
    export type DevicesControllerSetDeviceConfigMutationVariables = {deviceId: string;data: SetDeviceConfigDto}

    /**
 * @summary Set a device configuration value
 */
export const useDevicesControllerSetDeviceConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,DevicesControllerSetDeviceConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>,
        TError,
        DevicesControllerSetDeviceConfigMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesControllerSetDeviceConfigMutationOptions(options), queryClient);
    }
    export type devicesControllerClearStationResponse200 = {
  data: ClearDeviceResponseDto
  status: 200
}

export type devicesControllerClearStationResponse401 = {
  data: void
  status: 401
}

export type devicesControllerClearStationResponse403 = {
  data: void
  status: 403
}

export type devicesControllerClearStationResponse404 = {
  data: void
  status: 404
}

export type devicesControllerClearStationResponseSuccess = (devicesControllerClearStationResponse200) & {
  headers: Headers;
};
export type devicesControllerClearStationResponseError = (devicesControllerClearStationResponse401 | devicesControllerClearStationResponse403 | devicesControllerClearStationResponse404) & {
  headers: Headers;
};

export type devicesControllerClearStationResponse = (devicesControllerClearStationResponseSuccess | devicesControllerClearStationResponseError)

export const getDevicesControllerClearStationUrl = (deviceId: string,) => {




  return `/devices/${deviceId}/clear-station`
}

/**
 * Clears the device's current station, and signals the device so a Job Board device (which doesn't poll) picks it up at once.
 * @summary Clear the device station
 */
export const devicesControllerClearStation = async (deviceId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesControllerClearStationResponse> => {

  return customFetch<devicesControllerClearStationResponse>(getDevicesControllerClearStationUrl(deviceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDevicesControllerClearStationMutationKey = () => ['devicesControllerClearStation'] as const;

export const getDevicesControllerClearStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearStation>>, TError,DevicesControllerClearStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearStation>>, TError,DevicesControllerClearStationMutationVariables, TContext> => {

const mutationKey = getDevicesControllerClearStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesControllerClearStation>>, DevicesControllerClearStationMutationVariables> = (props) => {
          const {deviceId} = props ?? {};

          return  devicesControllerClearStation(deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesControllerClearStationMutationResult = NonNullable<Awaited<ReturnType<typeof devicesControllerClearStation>>>

    export type DevicesControllerClearStationMutationError = void
    export type DevicesControllerClearStationMutationVariables = {deviceId: string}

    /**
 * @summary Clear the device station
 */
export const useDevicesControllerClearStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearStation>>, TError,DevicesControllerClearStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesControllerClearStation>>,
        TError,
        DevicesControllerClearStationMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesControllerClearStationMutationOptions(options), queryClient);
    }
    export type devicesControllerClearJobCardsResponse200 = {
  data: ClearDeviceResponseDto
  status: 200
}

export type devicesControllerClearJobCardsResponse401 = {
  data: void
  status: 401
}

export type devicesControllerClearJobCardsResponse403 = {
  data: void
  status: 403
}

export type devicesControllerClearJobCardsResponse404 = {
  data: void
  status: 404
}

export type devicesControllerClearJobCardsResponseSuccess = (devicesControllerClearJobCardsResponse200) & {
  headers: Headers;
};
export type devicesControllerClearJobCardsResponseError = (devicesControllerClearJobCardsResponse401 | devicesControllerClearJobCardsResponse403 | devicesControllerClearJobCardsResponse404) & {
  headers: Headers;
};

export type devicesControllerClearJobCardsResponse = (devicesControllerClearJobCardsResponseSuccess | devicesControllerClearJobCardsResponseError)

export const getDevicesControllerClearJobCardsUrl = (deviceId: string,) => {




  return `/devices/${deviceId}/clear-job-cards`
}

/**
 * Clears the device's current job card(s) and batch, and signals the device so a Job Board device picks it up at once.
 * @summary Clear the device job cards
 */
export const devicesControllerClearJobCards = async (deviceId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesControllerClearJobCardsResponse> => {

  return customFetch<devicesControllerClearJobCardsResponse>(getDevicesControllerClearJobCardsUrl(deviceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDevicesControllerClearJobCardsMutationKey = () => ['devicesControllerClearJobCards'] as const;

export const getDevicesControllerClearJobCardsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearJobCards>>, TError,DevicesControllerClearJobCardsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearJobCards>>, TError,DevicesControllerClearJobCardsMutationVariables, TContext> => {

const mutationKey = getDevicesControllerClearJobCardsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesControllerClearJobCards>>, DevicesControllerClearJobCardsMutationVariables> = (props) => {
          const {deviceId} = props ?? {};

          return  devicesControllerClearJobCards(deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesControllerClearJobCardsMutationResult = NonNullable<Awaited<ReturnType<typeof devicesControllerClearJobCards>>>

    export type DevicesControllerClearJobCardsMutationError = void
    export type DevicesControllerClearJobCardsMutationVariables = {deviceId: string}

    /**
 * @summary Clear the device job cards
 */
export const useDevicesControllerClearJobCards = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerClearJobCards>>, TError,DevicesControllerClearJobCardsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesControllerClearJobCards>>,
        TError,
        DevicesControllerClearJobCardsMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesControllerClearJobCardsMutationOptions(options), queryClient);
    }
    export type devicesAdminControllerListDevicesResponse200 = {
  data: DeviceListItemDto[]
  status: 200
}

export type devicesAdminControllerListDevicesResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerListDevicesResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerListDevicesResponseSuccess = (devicesAdminControllerListDevicesResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerListDevicesResponseError = (devicesAdminControllerListDevicesResponse401 | devicesAdminControllerListDevicesResponse403) & {
  headers: Headers;
};

export type devicesAdminControllerListDevicesResponse = (devicesAdminControllerListDevicesResponseSuccess | devicesAdminControllerListDevicesResponseError)

export const getDevicesAdminControllerListDevicesUrl = (params?: DevicesAdminControllerListDevicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/devices?${stringifiedParams}` : `/admin/devices`
}

/**
 * Lists all devices, newest first. Optional device_id search. Artic admin only.
 * @summary List devices
 */
export const devicesAdminControllerListDevices = async (params?: DevicesAdminControllerListDevicesParams, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerListDevicesResponse> => {

  return customFetch<devicesAdminControllerListDevicesResponse>(getDevicesAdminControllerListDevicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDevicesAdminControllerListDevicesQueryKey = (params?: DevicesAdminControllerListDevicesParams,) => {
    return [
    `/admin/devices`, ...(params ? [params] : [])
    ] as const;
    }


export const getDevicesAdminControllerListDevicesQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>> = ({ signal }) => devicesAdminControllerListDevices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerListDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>>
export type DevicesAdminControllerListDevicesQueryError = void


export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params: undefined |  DevicesAdminControllerListDevicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List devices
 */

export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerListDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List devices
 */
export const prefetchDevicesAdminControllerListDevicesQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 queryClient: QueryClient, params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerListDevicesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getDevicesAdminControllerListDevicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>> = ({ signal }) => devicesAdminControllerListDevices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerListDevicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>>
export type DevicesAdminControllerListDevicesSuspenseQueryError = void


export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params: undefined |  DevicesAdminControllerListDevicesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List devices
 */

export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerListDevicesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type devicesAdminControllerCreateDeviceResponse201 = {
  data: DeviceDetailDto
  status: 201
}

export type devicesAdminControllerCreateDeviceResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerCreateDeviceResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerCreateDeviceResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerCreateDeviceResponse409 = {
  data: void
  status: 409
}

export type devicesAdminControllerCreateDeviceResponseSuccess = (devicesAdminControllerCreateDeviceResponse201) & {
  headers: Headers;
};
export type devicesAdminControllerCreateDeviceResponseError = (devicesAdminControllerCreateDeviceResponse400 | devicesAdminControllerCreateDeviceResponse401 | devicesAdminControllerCreateDeviceResponse403 | devicesAdminControllerCreateDeviceResponse409) & {
  headers: Headers;
};

export type devicesAdminControllerCreateDeviceResponse = (devicesAdminControllerCreateDeviceResponseSuccess | devicesAdminControllerCreateDeviceResponseError)

export const getDevicesAdminControllerCreateDeviceUrl = () => {




  return `/admin/devices`
}

/**
 * Creates a device with a generated device_auth_id and default config. device_id must be unique. Artic admin only.
 * @summary Register a device
 */
export const devicesAdminControllerCreateDevice = async (createDeviceAdminDto: CreateDeviceAdminDto, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerCreateDeviceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<devicesAdminControllerCreateDeviceResponse>(getDevicesAdminControllerCreateDeviceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createDeviceAdminDto)
  }
);}





export const getDevicesAdminControllerCreateDeviceMutationKey = () => ['devicesAdminControllerCreateDevice'] as const;

export const getDevicesAdminControllerCreateDeviceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,DevicesAdminControllerCreateDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,DevicesAdminControllerCreateDeviceMutationVariables, TContext> => {

const mutationKey = getDevicesAdminControllerCreateDeviceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, DevicesAdminControllerCreateDeviceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  devicesAdminControllerCreateDevice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerCreateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>>
    export type DevicesAdminControllerCreateDeviceMutationBody = CreateDeviceAdminDto
    export type DevicesAdminControllerCreateDeviceMutationError = void
    export type DevicesAdminControllerCreateDeviceMutationVariables = {data: CreateDeviceAdminDto}

    /**
 * @summary Register a device
 */
export const useDevicesAdminControllerCreateDevice = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,DevicesAdminControllerCreateDeviceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>,
        TError,
        DevicesAdminControllerCreateDeviceMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesAdminControllerCreateDeviceMutationOptions(options), queryClient);
    }
    export type devicesAdminControllerGetDeviceResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerGetDeviceResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerGetDeviceResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerGetDeviceResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerGetDeviceResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerGetDeviceResponseSuccess = (devicesAdminControllerGetDeviceResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerGetDeviceResponseError = (devicesAdminControllerGetDeviceResponse400 | devicesAdminControllerGetDeviceResponse401 | devicesAdminControllerGetDeviceResponse403 | devicesAdminControllerGetDeviceResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerGetDeviceResponse = (devicesAdminControllerGetDeviceResponseSuccess | devicesAdminControllerGetDeviceResponseError)

export const getDevicesAdminControllerGetDeviceUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}`
}

/**
 * Artic admin only.
 * @summary Get a device by id
 */
export const devicesAdminControllerGetDevice = async (deviceAuthId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerGetDeviceResponse> => {

  return customFetch<devicesAdminControllerGetDeviceResponse>(getDevicesAdminControllerGetDeviceUrl(deviceAuthId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDevicesAdminControllerGetDeviceQueryKey = (deviceAuthId: string,) => {
    return [
    `/admin/devices/${deviceAuthId}`
    ] as const;
    }


export const getDevicesAdminControllerGetDeviceQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerGetDeviceQueryKey(deviceAuthId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>> = ({ signal }) => devicesAdminControllerGetDevice(deviceAuthId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: deviceAuthId !== null && deviceAuthId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerGetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>>
export type DevicesAdminControllerGetDeviceQueryError = void


export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a device by id
 */

export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerGetDeviceQueryOptions(deviceAuthId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a device by id
 */
export const prefetchDevicesAdminControllerGetDeviceQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 queryClient: QueryClient, deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerGetDeviceQueryOptions(deviceAuthId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getDevicesAdminControllerGetDeviceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerGetDeviceQueryKey(deviceAuthId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>> = ({ signal }) => devicesAdminControllerGetDevice(deviceAuthId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerGetDeviceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>>
export type DevicesAdminControllerGetDeviceSuspenseQueryError = void


export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a device by id
 */

export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerGetDeviceSuspenseQueryOptions(deviceAuthId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type devicesAdminControllerUpdateConfigResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerUpdateConfigResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerUpdateConfigResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerUpdateConfigResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerUpdateConfigResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerUpdateConfigResponse409 = {
  data: void
  status: 409
}

export type devicesAdminControllerUpdateConfigResponseSuccess = (devicesAdminControllerUpdateConfigResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerUpdateConfigResponseError = (devicesAdminControllerUpdateConfigResponse400 | devicesAdminControllerUpdateConfigResponse401 | devicesAdminControllerUpdateConfigResponse403 | devicesAdminControllerUpdateConfigResponse404 | devicesAdminControllerUpdateConfigResponse409) & {
  headers: Headers;
};

export type devicesAdminControllerUpdateConfigResponse = (devicesAdminControllerUpdateConfigResponseSuccess | devicesAdminControllerUpdateConfigResponseError)

export const getDevicesAdminControllerUpdateConfigUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}/config`
}

/**
 * Shallow-merges the supplied config over the existing one. Turning job_board on also sets fast_flow and check_in_cards on and quality_issue_reporting off. Artic admin only.
 * @summary Update device config
 */
export const devicesAdminControllerUpdateConfig = async (deviceAuthId: string,
    updateDeviceConfigDto: UpdateDeviceConfigDto, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerUpdateConfigResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<devicesAdminControllerUpdateConfigResponse>(getDevicesAdminControllerUpdateConfigUrl(deviceAuthId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateDeviceConfigDto)
  }
);}





export const getDevicesAdminControllerUpdateConfigMutationKey = () => ['devicesAdminControllerUpdateConfig'] as const;

export const getDevicesAdminControllerUpdateConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,DevicesAdminControllerUpdateConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,DevicesAdminControllerUpdateConfigMutationVariables, TContext> => {

const mutationKey = getDevicesAdminControllerUpdateConfigMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, DevicesAdminControllerUpdateConfigMutationVariables> = (props) => {
          const {deviceAuthId,data} = props ?? {};

          return  devicesAdminControllerUpdateConfig(deviceAuthId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerUpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>>
    export type DevicesAdminControllerUpdateConfigMutationBody = UpdateDeviceConfigDto
    export type DevicesAdminControllerUpdateConfigMutationError = void
    export type DevicesAdminControllerUpdateConfigMutationVariables = {deviceAuthId: string;data: UpdateDeviceConfigDto}

    /**
 * @summary Update device config
 */
export const useDevicesAdminControllerUpdateConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,DevicesAdminControllerUpdateConfigMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>,
        TError,
        DevicesAdminControllerUpdateConfigMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesAdminControllerUpdateConfigMutationOptions(options), queryClient);
    }
    export type devicesAdminControllerClearStationResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerClearStationResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerClearStationResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerClearStationResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerClearStationResponseSuccess = (devicesAdminControllerClearStationResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerClearStationResponseError = (devicesAdminControllerClearStationResponse401 | devicesAdminControllerClearStationResponse403 | devicesAdminControllerClearStationResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerClearStationResponse = (devicesAdminControllerClearStationResponseSuccess | devicesAdminControllerClearStationResponseError)

export const getDevicesAdminControllerClearStationUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}/clear-station`
}

/**
 * Nulls device_metadata.current_station. Artic admin only.
 * @summary Clear the device current station
 */
export const devicesAdminControllerClearStation = async (deviceAuthId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerClearStationResponse> => {

  return customFetch<devicesAdminControllerClearStationResponse>(getDevicesAdminControllerClearStationUrl(deviceAuthId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDevicesAdminControllerClearStationMutationKey = () => ['devicesAdminControllerClearStation'] as const;

export const getDevicesAdminControllerClearStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,DevicesAdminControllerClearStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,DevicesAdminControllerClearStationMutationVariables, TContext> => {

const mutationKey = getDevicesAdminControllerClearStationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, DevicesAdminControllerClearStationMutationVariables> = (props) => {
          const {deviceAuthId} = props ?? {};

          return  devicesAdminControllerClearStation(deviceAuthId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerClearStationMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>>

    export type DevicesAdminControllerClearStationMutationError = void
    export type DevicesAdminControllerClearStationMutationVariables = {deviceAuthId: string}

    /**
 * @summary Clear the device current station
 */
export const useDevicesAdminControllerClearStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,DevicesAdminControllerClearStationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerClearStation>>,
        TError,
        DevicesAdminControllerClearStationMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesAdminControllerClearStationMutationOptions(options), queryClient);
    }
    export type devicesAdminControllerClearJobsResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerClearJobsResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerClearJobsResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerClearJobsResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerClearJobsResponseSuccess = (devicesAdminControllerClearJobsResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerClearJobsResponseError = (devicesAdminControllerClearJobsResponse401 | devicesAdminControllerClearJobsResponse403 | devicesAdminControllerClearJobsResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerClearJobsResponse = (devicesAdminControllerClearJobsResponseSuccess | devicesAdminControllerClearJobsResponseError)

export const getDevicesAdminControllerClearJobsUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}/clear-jobs`
}

/**
 * Nulls device_metadata.current_job_card / current_job_card_ids / current_batch_process_id. Artic admin only.
 * @summary Clear the device current jobs and batch
 */
export const devicesAdminControllerClearJobs = async (deviceAuthId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerClearJobsResponse> => {

  return customFetch<devicesAdminControllerClearJobsResponse>(getDevicesAdminControllerClearJobsUrl(deviceAuthId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDevicesAdminControllerClearJobsMutationKey = () => ['devicesAdminControllerClearJobs'] as const;

export const getDevicesAdminControllerClearJobsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,DevicesAdminControllerClearJobsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,DevicesAdminControllerClearJobsMutationVariables, TContext> => {

const mutationKey = getDevicesAdminControllerClearJobsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, DevicesAdminControllerClearJobsMutationVariables> = (props) => {
          const {deviceAuthId} = props ?? {};

          return  devicesAdminControllerClearJobs(deviceAuthId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerClearJobsMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>>

    export type DevicesAdminControllerClearJobsMutationError = void
    export type DevicesAdminControllerClearJobsMutationVariables = {deviceAuthId: string}

    /**
 * @summary Clear the device current jobs and batch
 */
export const useDevicesAdminControllerClearJobs = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,DevicesAdminControllerClearJobsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>,
        TError,
        DevicesAdminControllerClearJobsMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesAdminControllerClearJobsMutationOptions(options), queryClient);
    }
    export type devicesAdminControllerListPartnersResponse200 = {
  data: DevicePartnerDto[]
  status: 200
}

export type devicesAdminControllerListPartnersResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerListPartnersResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerListPartnersResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerListPartnersResponseSuccess = (devicesAdminControllerListPartnersResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerListPartnersResponseError = (devicesAdminControllerListPartnersResponse401 | devicesAdminControllerListPartnersResponse403 | devicesAdminControllerListPartnersResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerListPartnersResponse = (devicesAdminControllerListPartnersResponseSuccess | devicesAdminControllerListPartnersResponseError)

export const getDevicesAdminControllerListPartnersUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}/partners`
}

/**
 * Artic admin only.
 * @summary List partners linked to a device
 */
export const devicesAdminControllerListPartners = async (deviceAuthId: string, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerListPartnersResponse> => {

  return customFetch<devicesAdminControllerListPartnersResponse>(getDevicesAdminControllerListPartnersUrl(deviceAuthId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDevicesAdminControllerListPartnersQueryKey = (deviceAuthId: string,) => {
    return [
    `/admin/devices/${deviceAuthId}/partners`
    ] as const;
    }


export const getDevicesAdminControllerListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListPartnersQueryKey(deviceAuthId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>> = ({ signal }) => devicesAdminControllerListPartners(deviceAuthId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: deviceAuthId !== null && deviceAuthId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>>
export type DevicesAdminControllerListPartnersQueryError = void


export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List partners linked to a device
 */

export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerListPartnersQueryOptions(deviceAuthId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List partners linked to a device
 */
export const prefetchDevicesAdminControllerListPartnersQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 queryClient: QueryClient, deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerListPartnersQueryOptions(deviceAuthId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getDevicesAdminControllerListPartnersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListPartnersQueryKey(deviceAuthId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>> = ({ signal }) => devicesAdminControllerListPartners(deviceAuthId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevicesAdminControllerListPartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>>
export type DevicesAdminControllerListPartnersSuspenseQueryError = void


export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List partners linked to a device
 */

export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevicesAdminControllerListPartnersSuspenseQueryOptions(deviceAuthId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type devicesAdminControllerSetPartnerResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerSetPartnerResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerSetPartnerResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerSetPartnerResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerSetPartnerResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerSetPartnerResponse409 = {
  data: void
  status: 409
}

export type devicesAdminControllerSetPartnerResponseSuccess = (devicesAdminControllerSetPartnerResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerSetPartnerResponseError = (devicesAdminControllerSetPartnerResponse400 | devicesAdminControllerSetPartnerResponse401 | devicesAdminControllerSetPartnerResponse403 | devicesAdminControllerSetPartnerResponse404 | devicesAdminControllerSetPartnerResponse409) & {
  headers: Headers;
};

export type devicesAdminControllerSetPartnerResponse = (devicesAdminControllerSetPartnerResponseSuccess | devicesAdminControllerSetPartnerResponseError)

export const getDevicesAdminControllerSetPartnerUrl = (deviceAuthId: string,) => {




  return `/admin/devices/${deviceAuthId}/partner`
}

/**
 * Assigns a single owning partner (reconciling the partners_devices join to exactly that partner), or null to make it an Admin Device. Setting null is rejected (409) while the device still has partner links — admin all-access enforcement is deferred. Artic admin only.
 * @summary Set the device's owning partner
 */
export const devicesAdminControllerSetPartner = async (deviceAuthId: string,
    setDevicePartnerDto: SetDevicePartnerDto, options?: Parameters<typeof customFetch>[1]): Promise<devicesAdminControllerSetPartnerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<devicesAdminControllerSetPartnerResponse>(getDevicesAdminControllerSetPartnerUrl(deviceAuthId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setDevicePartnerDto)
  }
);}





export const getDevicesAdminControllerSetPartnerMutationKey = () => ['devicesAdminControllerSetPartner'] as const;

export const getDevicesAdminControllerSetPartnerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,DevicesAdminControllerSetPartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,DevicesAdminControllerSetPartnerMutationVariables, TContext> => {

const mutationKey = getDevicesAdminControllerSetPartnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, DevicesAdminControllerSetPartnerMutationVariables> = (props) => {
          const {deviceAuthId,data} = props ?? {};

          return  devicesAdminControllerSetPartner(deviceAuthId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerSetPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>>
    export type DevicesAdminControllerSetPartnerMutationBody = SetDevicePartnerDto
    export type DevicesAdminControllerSetPartnerMutationError = void
    export type DevicesAdminControllerSetPartnerMutationVariables = {deviceAuthId: string;data: SetDevicePartnerDto}

    /**
 * @summary Set the device's owning partner
 */
export const useDevicesAdminControllerSetPartner = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,DevicesAdminControllerSetPartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>,
        TError,
        DevicesAdminControllerSetPartnerMutationVariables,
        TContext
      > => {
      return useMutation(getDevicesAdminControllerSetPartnerMutationOptions(options), queryClient);
    }
